"use client";

import { c as _c } from "react/compiler-runtime";
import { DesktopNavigation } from "@/layouts/app-shell/navigation/desktop-navigation/desktop-navigation";
import { MobileNavigation } from "@/layouts/app-shell/navigation/mobile-navigation/mobile-navigation";
import { SidebarInset, SidebarLayoutProvider } from "@/layouts/app-shell/sidebar-layout";
import { getSidebarConfig } from "@/config/sidebar-configs";
import { type SidebarConfig } from "@/types/sidebar";
import { usePathname } from "next/navigation";
export type AppShellProps = {
  children: React.ReactNode;
  config?: SidebarConfig;
  useRouteConfig?: boolean;
};
export function AppShell(t0) {
  const $ = _c(13);
  const {
    children,
    config,
    useRouteConfig: t1
  } = t0;
  const useRouteConfig = t1 === undefined ? true : t1;
  const pathname = usePathname();
  let t2;
  if ($[0] !== config || $[1] !== pathname || $[2] !== useRouteConfig) {
    t2 = useRouteConfig ? getSidebarConfig(pathname) : config;
    $[0] = config;
    $[1] = pathname;
    $[2] = useRouteConfig;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const sidebarConfig = t2;
  let t3;
  let t4;
  if ($[4] !== sidebarConfig) {
    t3 = <DesktopNavigation config={sidebarConfig} />;
    t4 = <MobileNavigation config={sidebarConfig} />;
    $[4] = sidebarConfig;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children) {
    t5 = <SidebarInset>{children}</SidebarInset>;
    $[7] = children;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <SidebarLayoutProvider>{t3}{t4}{t5}</SidebarLayoutProvider>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}